module.exports = __webpack_public_path__ + "img/adv_upload.1df31b14.png";